var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9233 6.59174L16.9082 2.57752C16.7747 2.444 16.6162 2.33809 16.4418 2.26583C16.2673 2.19356 16.0804 2.15637 15.8916 2.15637C15.7028 2.15637 15.5158 2.19356 15.3414 2.26583C15.167 2.33809 15.0085 2.444 14.875 2.57752L3.79637 13.6562C3.66231 13.7892 3.55602 13.9475 3.48368 14.1219C3.41134 14.2964 3.3744 14.4834 3.37501 14.6723V18.6874C3.37501 19.0687 3.52646 19.4343 3.79604 19.7039C4.06562 19.9735 4.43126 20.1249 4.81251 20.1249H19.9063C20.0969 20.1249 20.2797 20.0492 20.4145 19.9144C20.5493 19.7796 20.625 19.5968 20.625 19.4062C20.625 19.2155 20.5493 19.0327 20.4145 18.8979C20.2797 18.7631 20.0969 18.6874 19.9063 18.6874H10.8608L20.9233 8.6249C21.0568 8.49142 21.1627 8.33293 21.235 8.15851C21.3072 7.98408 21.3444 7.79712 21.3444 7.60832C21.3444 7.41952 21.3072 7.23257 21.235 7.05814C21.1627 6.88371 21.0568 6.72523 20.9233 6.59174ZM8.82762 18.6874H4.81251V14.6723L12.7188 6.76604L16.7339 10.7812L8.82762 18.6874ZM17.75 9.76502L13.7358 5.7499L15.892 3.59365L19.9063 7.60877L17.75 9.76502Z",
    fill: "#8A8C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.ad492ea964f76b546f570d028d9a9272.svg";
export { ForwardRef as ReactComponent };